import { Badge } from '@lectura/ui';
import type { IngestionStatus, QueueSnapshotItem } from '@lectura/ts-contracts';
import type { Route } from 'next';
import Link from 'next/link';
import { ChevronRight } from 'lucide-react';

const STATUSZ_CIMKE: Record<IngestionStatus, { label: string; variant: 'info' | 'warning' | 'success' | 'danger' | 'neutral' }> = {
  queued: { label: 'sorban', variant: 'neutral' },
  uploading: { label: 'feltöltés', variant: 'info' },
  uploaded: { label: 'feltöltve', variant: 'info' },
  scanning: { label: 'vírusszkennelés', variant: 'warning' },
  validating: { label: 'validálás', variant: 'warning' },
  converting: { label: 'konverzió', variant: 'info' },
  optimizing: { label: 'optimalizálás', variant: 'info' },
  indexing: { label: 'indexelés', variant: 'info' },
  completed: { label: 'kész', variant: 'success' },
  failed: { label: 'hiba', variant: 'danger' },
  cancelled: { label: 'megszakítva', variant: 'neutral' },
};

/**
 * A dashboard "Konverziós sor" boxban szereplő rövid lista — max 4-5 job.
 * A teljes sort a /queue oldalon nézi a felhasználó; itt csak gyors pillanatkép.
 */
export function QueueSnapshotList({ items }: { items: QueueSnapshotItem[] }) {
  if (items.length === 0) {
    return (
      <p className="py-6 text-center text-sm text-[var(--color-foreground-muted)]">
        Nincs aktív konverziós feladat.
      </p>
    );
  }

  return (
    <ul className="space-y-3">
      {items.map((u) => {
        const meta = STATUSZ_CIMKE[u.status];
        return (
          <li key={u.id}>
            <Link
              href={`/uploads/${u.id}` as Route}
              className="group flex items-center gap-3 rounded-xl px-2 py-1.5 transition-colors hover:bg-[var(--color-surface-muted)]"
            >
              <div className="min-w-0 flex-1">
                <p className="truncate font-mono text-xs">{u.filename}</p>
                <div className="mt-1 h-1.5 w-full overflow-hidden rounded-full bg-brand-100">
                  <div
                    className="h-full rounded-full bg-gradient-to-r from-brand-500 to-brand-700 transition-all"
                    style={{ width: `${u.progressPercent}%` }}
                  />
                </div>
              </div>
              <Badge variant={meta.variant}>{meta.label}</Badge>
              <ChevronRight className="size-4 shrink-0 text-[var(--color-foreground-subtle)] transition-colors group-hover:text-brand-600" />
            </Link>
          </li>
        );
      })}
    </ul>
  );
}
